import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/markers/gift.svg")